import { debounce, difference, keys } from 'lodash';
// Collects all 'client-typing' events and converts them to 'start' and 'end' events
export function initSomeoneIsTypingManager({ emitStartTo: emitStart, emitEndTo: emitEnd, timeout, getCurrentTypingStates, }) {
    const activeResources = {};
    return {
        collect: (resourceId) => {
            if (!activeResources[resourceId]) {
                activeResources[resourceId] = debounce(() => {
                    if (getCurrentTypingStates()[resourceId] === 'started') {
                        emitEnd(resourceId);
                    }
                }, timeout);
            }
            const callDebouncedEnd = activeResources[resourceId];
            if (getCurrentTypingStates()[resourceId] !== 'started') {
                emitStart(resourceId);
            }
            callDebouncedEnd();
        },
        // lets not leak memorry!
        dropNotReady: () => {
            difference(keys(activeResources), keys(getCurrentTypingStates())).forEach((resourceId) => {
                activeResources[resourceId].cancel();
                delete activeResources[resourceId];
            });
        },
    };
}
//# sourceMappingURL=someone-is-typing-manager.js.map